import { AxiosResponse } from 'axios';
import { IErrors, isIErrors } from './errors.model';

export interface IResponseError {
  errors: IErrors;
  bodyResponse: AxiosResponse;
}

export interface IServerError {
  message: string;
  messageException: string;
}

export interface IFile {
  stream: string;// Stream;
  fileName: string;
  mimeType: string;
}

export interface IResponseData {
  data: any;
  file: IFile;
  error: IServerError;
  statusCode: number;
  errors?: any;
}

function isAxiosResponse(obj: any): obj is AxiosResponse {
  return (
    obj &&
    typeof obj === 'object' &&
    'data' in obj &&
    'status' in obj &&
    'statusText' in obj &&
    'headers' in obj &&
    'config' in obj &&
    'request' in obj &&
    typeof obj.status === 'number' &&
    typeof obj.statusText === 'string' &&
    typeof obj.headers === 'object' &&
    typeof obj.config === 'object' &&
    typeof obj.request === 'object'
  );
}

export function isIResponseError(obj: any): obj is IResponseError {
  return (
    isIErrors(obj.errors) &&
    isAxiosResponse(obj.bodyResponse)
  );
}

export async function getData(response: AxiosResponse): Promise<any> {
  if (response.data.type == 'application/json' || response.data.type.endsWith('json')) {
    const isJsonBlob = (data: any) => data instanceof Blob && (data.type === "application/json" || data.type.endsWith('json'));
    const responseData = isJsonBlob(response?.data) ? await(response?.data)?.text() : response?.data || {};
    const responseJson = (typeof responseData === "string") ? JSON.parse(responseData) : responseData;
    return responseJson;
  }

  return response;
}
